const { useSnackbar } = require("notistack");

const useErrors = () => {
  const { enqueueSnackbar } = useSnackbar();

  return (err) => {
    // Handle case where err.errors doesn't exist
    if (!err || !err.errors) {
      // If there's a general message, show it
      if (err?.message) {
        return enqueueSnackbar(err.message, { variant: "error" });
      }
      // Default error message
      return enqueueSnackbar("An error occurred", { variant: "error" });
    }

    // Original behavior when err.errors exists
    return Object.values(err.errors).flatMap((item) =>
      enqueueSnackbar(item, { variant: "error" })
    );
  };
};

export default useErrors;
